// extracted by mini-css-extract-plugin
module.exports = {"edit":"text-blur-button_edit__3m7Yq","blue":"text-blur-button_blue__2AQTG","red":"text-blur-button_red__34-uM"};